export const SITE_ORIGIN = "https://ibtkary.com";
export const LANGUAGES = ["ar", "en"] as const;
export type Language = (typeof LANGUAGES)[number];
export const DEFAULT_LANGUAGE: Language = "ar";

export function normalizePath(path: string): string {
  const separator = path.search(/[?#]/);
  const pathname = separator < 0 ? path : path.slice(0, separator);
  const suffix = separator < 0 ? "" : path.slice(separator);
  return (pathname.replace(/\/+$/, "") || "/") + suffix;
}

export function getPathLanguage(path: string): Language | undefined {
  const match = /^\/(ar|en)(?:\/|$)/.exec(path);
  return match?.[1] as Language | undefined;
}

export function getPagePath(path: string): string {
  const pathname = path.split(/[?#]/)[0];
  return normalizePath(pathname.replace(/^\/(ar|en)(?=\/|$)/, "") || "/");
}

export function localizedPath(language: Language, pagePath = "/"): string {
  return normalizePath(`/${language}${pagePath.startsWith("/") ? pagePath : `/${pagePath}`}`);
}
